import React from "react";
import { observer } from "mobx-react";
import css from './navFloor.module.scss'
import { NavLink, useHistory } from "react-router-dom";
import MyRouter from "router/router";
import { logoStyle } from "api/commonApi";
import Router from "@/router/router";
import useMyStores from "@/hooks/useMyStores";
import useFetchNav from "@/hooks/useFetchNav";

const Index = () => {
    let history = useHistory();

    const { app: appStore } = useMyStores();
    const { data: nav } = useFetchNav()

    return (
        <div className={css.root}>
            <div className={css.logoWrapper}>
                {appStore.logo && <img style={logoStyle} src={appStore.logo} alt='' />}
            </div>

            <div className={css.navList}>
                <div className={css.item}>
                    <div className={css.linkWrapper}>
                        <NavLink to={MyRouter.Home.path}>
                            首页
                        </NavLink>
                    </div>
                </div>
                <div className={css.item}>
                    <div className={css.linkWrapper}>
                        <NavLink
                            to={MyRouter.Search.path}
                            onClick={e => {
                                e.preventDefault();
                                let category = {
                                    id: 0,
                                    optId: 0,
                                    name: nav?.selfRun,
                                    isSelf: true,
                                    icon: "",
                                    iconActive: "",
                                    parentId: -1
                                };

                                const toSearch = ({
                                    categoryId,
                                    categoryName,
                                    categorySelf,
                                    parentId
                                }) => {
                                    let search = "";
                                    if (categoryName) {
                                        search = `?parentCategoryId=${parentId}&categoryId=${categoryId}&categoryName=${categoryName}&categorySelf=${categorySelf}`;
                                    }
                                    history.push({
                                        pathname: MyRouter.Search.path,
                                        search
                                    });
                                };

                                toSearch({
                                    categoryId: category.optId,
                                    categoryName: category.name,
                                    categorySelf: category.isSelf,
                                    parentId: category.parentId
                                });
                            }}
                        >
                            {nav?.selfRun}
                        </NavLink>
                    </div>
                </div>
                <div className={css.item}>
                    <div className={css.linkWrapper}>
                        <NavLink to={MyRouter.ShopStreet.path}>
                            {nav?.shopStreet}
                        </NavLink>
                    </div>
                </div>
                <div className={css.item}>
                    <div className={css.linkWrapper}>
                        <NavLink to={MyRouter.News.realPath}>
                            {nav?.news}
                        </NavLink>
                    </div>
                </div>
                {
                    appStore.decorateConfig?.metaFlag &&
                    <div className={css.item}>
                        <div className={css.linkWrapper}>
                            <NavLink to={MyRouter.Meta.path} onClick={e => {
                                e.preventDefault();

                                window.open(`${window.location.protocol}//${window.location.host}${MyRouter.Meta.path}`, "_blank");
                            }}>
                                {nav?.meta}
                            </NavLink>
                        </div>
                    </div>
                }
                <div className={css.item}>
                    <div className={css.linkWrapper}>
                        <NavLink to={Router.SecKill.path}>
                            {nav?.secKill}
                        </NavLink>
                    </div>
                </div>
                <div className={css.item}>
                    <div className={css.linkWrapper}>
                        <NavLink to={MyRouter.Merchant.path}>
                            {nav?.merchant}
                        </NavLink>
                    </div>
                </div>
                <div className={css.item}>
                    <div className={css.linkWrapper}>
                        <NavLink to={MyRouter.Introduce.path}>
                            {nav?.introduce}
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Index)